"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_native_1 = require("react-native");
const Text = (_a) => {
    var { styles, style } = _a, rest = tslib_1.__rest(_a, ["styles", "style"]);
    return (<react_native_1.Text style={[styles && styles.root, style]} {...rest}/>);
};
exports.Text = Text;
exports.Text.defaultStyles = (theme) => ({ root: theme.typography.body1 });
